import * as types from '../types/categoryTypes';
import * as categoryServices from '../../services/categoryServices';

// Fetch all categories (with optional language/region)
export const fetchCategories = (params = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_CATEGORIES_REQUEST });
  try {
    const response = await categoryServices.getAllCategories(params);
    dispatch({ 
      type: types.FETCH_CATEGORIES_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while fetching categories';
    dispatch({ type: types.FETCH_CATEGORIES_FAILURE, payload: errorMessage });
  }
};

// Fetch popular categories (with optional language/region)
export const fetchPopularCategories = (limit = 4, params = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_POPULAR_CATEGORIES_REQUEST });
  try {
    const response = await categoryServices.getPopularCategories(limit, params);
    dispatch({ 
      type: types.FETCH_POPULAR_CATEGORIES_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while fetching popular categories';
    dispatch({ type: types.FETCH_POPULAR_CATEGORIES_FAILURE, payload: errorMessage });
  }
};

// Fetch category by slug (with optional language and region)
export const fetchCategoryBySlug = (slug, lang = null, region = null) => async (dispatch) => {
  dispatch({ type: types.FETCH_CATEGORY_BY_SLUG_REQUEST });
  try {
    const response = await categoryServices.getCategoryBySlug(slug, lang, region);
    dispatch({ 
      type: types.FETCH_CATEGORY_BY_SLUG_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while fetching the category';
    dispatch({ type: types.FETCH_CATEGORY_BY_SLUG_FAILURE, payload: errorMessage });
  }
};

// Fetch articles by category
export const fetchCategoryArticles = (slug, params = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_CATEGORY_ARTICLES_REQUEST });
  try {
    const response = await categoryServices.getCategoryArticles(slug, params);
    dispatch({ 
      type: types.FETCH_CATEGORY_ARTICLES_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while fetching category articles';
    dispatch({ type: types.FETCH_CATEGORY_ARTICLES_FAILURE, payload: errorMessage });
  }
};

// Create category (Admin only)
export const createCategory = (categoryData) => async (dispatch) => {
  dispatch({ type: types.CREATE_CATEGORY_REQUEST });
  try {
    const response = await categoryServices.createCategory(categoryData);
    dispatch({ 
      type: types.CREATE_CATEGORY_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while creating the category';
    dispatch({ type: types.CREATE_CATEGORY_FAILURE, payload: errorMessage });
  }
};

// Update category (Admin only)
export const updateCategory = (id, categoryData) => async (dispatch) => {
  dispatch({ type: types.UPDATE_CATEGORY_REQUEST });
  try {
    const response = await categoryServices.updateCategory(id, categoryData);
    dispatch({ 
      type: types.UPDATE_CATEGORY_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while updating the category';
    dispatch({ type: types.UPDATE_CATEGORY_FAILURE, payload: errorMessage });
  }
};

// Delete category (Admin only)
export const deleteCategory = (id) => async (dispatch) => {
  dispatch({ type: types.DELETE_CATEGORY_REQUEST });
  try {
    await categoryServices.deleteCategory(id);
    dispatch({ type: types.DELETE_CATEGORY_SUCCESS, payload: id });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while deleting the category';
    dispatch({ type: types.DELETE_CATEGORY_FAILURE, payload: errorMessage });
  }
};


